export const passwordValidator = (value) => {
    if ((/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/).test(value)) {
        return { valid: true, error: false }
    } else { return { valid: false, error: 'Password must contain atleast 8 characters, atlest one Special Character, one Numeric and one Uppercase and one Lowercase Character' } }
}